import React from 'react';

export default {
  svg: (
    <g
      id="GC-Get-Care-Now---Emotional-Support---Web"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
    >
      <g
        id="GC-Get-Care-Emotional-Support"
        transform="translate(-964.000000, -433.000000)"
        fill="#107686"
      >
        <path
          d="M975.988,433 C969.364,433 964,438.376 964,445 C964,451.624 969.364,457 975.988,457 C982.624,457 988,451.624 988,445 C988,438.376 982.624,433 975.988,433 Z M976,454.6 C970.696,454.6 966.4,450.304 966.4,445 C966.4,439.696 970.696,435.4 976,435.4 C981.304,435.4 985.6,439.696 985.6,445 C985.6,450.304 981.304,454.6 976,454.6 Z M976.6,439 L974.8,439 L974.8,446.2 L981.1,449.98 L982,448.504 L976.6,445.3 L976.6,439 Z"
          id="Shape"
        ></path>
      </g>
    </g>
  ),
  viewBox: '0 0 24 24'
};
